import * as R from 'ramda';

const groupPaidByTransactionID = R.compose(
	R.map(R.last),
	R.toPairs,
	R.groupBy(R.prop('transaction_id')),
	R.filter(R.propEq('is_paid', true))
);

const countPaidInvoices = R.compose(
	R.length,
	R.keys,
	R.groupBy(R.prop('id')),
	R.filter(R.propEq('is_paid', true))
);

export { groupPaidByTransactionID, countPaidInvoices };
